import {
  MDBAlert,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBInputGroup,
  MDBSpinner,
  MDBTextArea,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import SaveChanges from "../../../components/topviews/saveCancel";
import {
  forwardANewGroupFax,
  forwardNewFax,
  sendANewFax,
  sendANewGroupFax,
} from "../../../apiclients/streamsapi_bridge";
import TopSuccess from "../../../components/header/TopSuccess";
import TopMessage from "../../../components/header/TopMessage";
import { encryptToBase64 } from "../../../components/topviews/accountsettings/AccLoginSettings";
import { validatePhoneNumber } from "../phonenumbers/AddRemoveNumbers";

function SendAFax({
  faxPhoneNums,
  uniqueid,
  faxDomain,
  primaryFax,
  groupFaxFlag,
  forwardFlag,
  userList,
  existFileName,
  groupname,
  selectedFaxId,
  onClose,
}) {
  const { t, i18n } = useTranslation();
  const [copySuccess, setCopySuccess] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [internalError, setInternalError] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const fileInputRef = useRef(null);

  const {
    register,
    handleSubmit,
    formState: { isDirty, dirtyFields, errors },
    setValue,
    getValues,
    clearErrors,
    setError,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      to_num: "",
      from_num: "",
      from_user: "",
      company: "",
      from: "",
      re: "",
      message: "",
      fax_upload: {},
      include_cover_page: false,
    },
  });

  const [fileName, setfileName] = useState("");

  const [successMessage, setSuccessMessage] = useState("");
  const [selectedFiles, setselectedFiles] = useState(null);

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage("");
      }, 5000);
    }
  }, [successMessage]);

  useEffect(() => {
    if (userList && userList.length > 0) {
      setValue("from_user", userList[0].agentid + "", { shouldDirty: true });
    }
  }, [userList]);

  //   const handleCheckboxChange = (event) => {
  //     setIsChecked(event.target.checked);
  //   };

  async function handleTocopy() {
    try {
      await navigator.clipboard.writeText(faxDomain);
      setCopySuccess(true);
      setTimeout(() => {
        setCopySuccess(false);
      }, 2000); // Clear success message after 2 seconds
    } catch (error) {
      console.error("Failed to copy:", error);
    }
  }

  useEffect(() => {
    if (primaryFax) {
      reset({ ...getValues(), from_num: primaryFax });
    }
  }, [primaryFax]);

  const onsubmit = async (data) => {
    setInternalError(false);
    const formData = new FormData();
    let uploadFile = null;
    // if (selectedFiles) {
    //   formData.append("reqid", 150);
    //   uploadFile = await encryptToBase64(selectedFiles);
    // }
    let updates = {};
    if (isDirty) {
      // updates = {
      // siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      // to_num: data.to_num,
      // from_num: data.from_num,
      // fax_upload: {},
      // include_cover_page: data.include_cover_page,
      formData.append(
        "siteid",
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      formData.append("to_num", data.to_num);
      formData.append("from_num", data.from_num);
      formData.append("include_cover_page", data.include_cover_page);
      // };
      if (groupFaxFlag) {
        // updates.reqid = forwardFlag ? 153 : 120;
        // updates.code = uniqueid;
        // updates.name = groupname;
        // updates.from_user = data.from_user;
        // updates.fax_id = selectedFaxId;
        formData.append("reqid", forwardFlag ? 153 : 120);
        formData.append("code", uniqueid);
        formData.append("name", groupname);
        formData.append("from_user", data.from_user);
        if (selectedFaxId && selectedFaxId !== "") {
          formData.append("fax_id", selectedFaxId);
        }
      } else {
        // updates.reqid = forwardFlag ? 154 : 119;
        // updates.agentid = uniqueid;
        // updates.fax_id = selectedFaxId;
        formData.append("reqid", forwardFlag ? 154 : 119);
        formData.append("agentid", uniqueid);
        if (selectedFaxId && selectedFaxId !== "") {
          formData.append("fax_id", selectedFaxId);
        }
      }
      if (data.company !== "") {
        // updates.company = data.company;
        formData.append("company", data.company);
      }
      if (data.from !== "") {
        // updates.from = data.from;
        formData.append("from", data.from);
      }
      if (data.re !== "") {
        // updates.re = data.re;
        formData.append("re", data.re);
      }
      if (data.message !== "") {
        // updates.message = data.message;
        formData.append("message", data.message);
      }
      if (selectedFiles) {
        // updates.fax_upload.file_name = fileName;
        // updates.fax_upload.file_content = uploadFile;
        const faxUploadObj = {
          // file_name: fileName,
          file_content: selectedFiles,
        };
        const blob = new Blob([selectedFiles], { type: "application/pdf" });
        formData.append("fax_upload", blob, fileName);
      } else if (forwardFlag) {
        // updates.fax_upload.file_name = existFileName;
        const faxUploadObj = {
          file_name: existFileName,
        };
        formData.append("fax_upload", JSON.stringify(faxUploadObj));
      }
    }
    //alert(JSON.stringify(updates))
    // console.log("JSON sendANewFax:: " + JSON.stringify(formData));
    for (let [key, value] of formData.entries()) {
      console.log(`JSON sendANewFax::  ${key}: ${value}`);
    }

    setIsloading(true);
    let saverep = {};
    if (groupFaxFlag) {
      if (forwardFlag) {
        saverep = await forwardANewGroupFax(formData);
      } else {
        saverep = await sendANewGroupFax(formData);
      }
    } else {
      saverep = forwardFlag
        ? await forwardNewFax(formData)
        : await sendANewFax(formData);
    }
    console.log(`reponse of sendANewFax :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      `reponse of sendANewFax after:::: ${JSON.stringify(saverepeMsg)}`
    );
    setTimeout(() => {
      setIsloading(false);
    }, 2000);
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setSuccessMessage(saverepeMsg.message);
      reset();
      if (forwardFlag) {
        onClose();
      }
    } else {
      if (saverepeMsg.message?.errors) {
        saverepeMsg.message.errors.forEach((err) => {
          setError(err.param_name, {
            type: "server",
            message: err.message,
          });
          const fieldElement = document.querySelector(
            `input[name="${err.param_name}"]`
          );
          if (fieldElement) {
            fieldElement.focus();
          }
        });
      } else {
        setInternalError(true);
        seterrorMessage(saverepeMsg?.message);
        if (forwardFlag) {
          onClose();
        }
      }
    }
  };

  const handleFileChange = (event) => {
    clearErrors("fax_upload.file_name");
    clearErrors("fax_upload.file_content");
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileSizeInMB = selectedFile.size / (1024 * 1024); // Convert bytes to MB

      if (fileSizeInMB > 18) {
        alert(
          `File '${selectedFile.name}' exceeds the maximum file size of 18 MB.`
        );
        event.target.value = null;
        return;
      }
      if (selectedFile.type !== "application/pdf") {
        alert("Invalid file type. Please upload a .pdf file.");
        event.target.value = null;
        return;
      } else {
        setselectedFiles(selectedFile);
        setfileName(selectedFile.name);
      }
    }
  };

  return (
    <>
      {groupFaxFlag && userList.length === 0 ? (
        <p className="text-danger">
          You cannot send fax from this group as none of the user(s) in this
          group has the privilege to send fax. To send a fax from this group,
          add at least one user with the privilege to send fax.
        </p>
      ) : (
        <>
          <div className="p-3 mob-w-100">
            {!forwardFlag && (
              <div class="general-settings pb-3">{t("SendaFax")}</div>
            )}

            <div class="add-numbermain">
              <div class="tel-numbers">{t("from")}</div>
              <div className="w-30">
                <select
                  name=""
                  id=""
                  className="form-control form-select selectname w-100"
                  {...register("from_num", {
                    setValueAs: (value) => Number(value),
                    required: "From Number is required",
                  })}
                >
                  {faxPhoneNums &&
                    faxPhoneNums.length > 0 &&
                    faxPhoneNums.map((number) => (
                      <option value={number}>{number}</option>
                    ))}
                </select>
                {errors.from_num && (
                  <p className="text-danger">{errors.from_num.message}</p>
                )}
              </div>
            </div>
            {groupFaxFlag && (
              <div class="add-numbermain">
                <div class="tel-numbers">{t("From User")}</div>
                <div className="w-30">
                  <select
                    name=""
                    id=""
                    className="form-control form-select selectname w-100"
                    // {...register("from_user", {
                    //   setValueAs: (value) => Number(value),
                    //   required: "From User is required",
                    // })}

                    value={watch("from_user")}
                    onChange={(e) =>
                      setValue("from_user", e.target.value, {
                        shouldDirty: true,
                      })
                    }
                  >
                    {userList &&
                      userList.length > 0 &&
                      userList.map((user) => (
                        <option value={user.agentid}>{user.name}</option>
                      ))}
                  </select>
                  {errors.from_num && (
                    <p className="text-danger">{errors.from_user.message}</p>
                  )}
                </div>
              </div>
            )}

        <div class="add-numbermain">
          <div class="tel-numbers">To Fax Number</div>
          <div className="faxnumber" style={{ minWidth: "30%" }}>
            <MDBInputGroup noBorder textBefore="+1">
              <input
                className="form-control"
                type="text"
                onKeyPress={(event) =>{
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                {...register("to_num", {
                  setValueAs: (value) => value,
                  required: "Please check the Fax Number",
                  validate: (value) => {
                    const result = validatePhoneNumber(value);
                    return result === true ? true : "Please enter a valid 10-digit US or Canadian fax number.";
                  }
                })}
              />

                  <div className="d-flex align-items-center ms-2">
                    @{faxDomain}{" "}
                    <MDBIcon
                      far
                      icon="copy"
                      onClick={handleTocopy}
                      className="ms-2"
                    />
                  </div>
                </MDBInputGroup>
                {errors.to_num && (
                  <p className="text-danger">{errors.to_num.message}</p>
                )}
                {copySuccess && (
                  <span className="mt-2 ms-2 text-success">
                    Copied successfully.
                  </span>
                )}
              </div>
            </div>

            <div class="add-numbermain">
              <div class="tel-numbers">Include Cover Page</div>
              <div className="">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("include_cover_page")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            {watch("include_cover_page") && (
              <>
                <div class="add-numbermain">
                  <div class="tel-numbers">Company</div>
                  <div className="w-30">
                    <MDBInput {...register("company")} />
                    {errors.company && (
                      <p className="text-danger">{errors.company.message}</p>
                    )}
                  </div>
                </div>
                <div class="add-numbermain">
                  <div class="tel-numbers">{t("from")}</div>
                  <div className="w-30">
                    <MDBInput {...register("from")} />
                    {errors.from && (
                      <p className="text-danger">{errors.from.message}</p>
                    )}
                  </div>
                </div>
                <div class="add-numbermain">
                  <div class="tel-numbers">RE</div>
                  <div className="w-30">
                    <MDBInput {...register("re")} />
                    {errors.re && (
                      <p className="text-danger">{errors.re.message}</p>
                    )}
                  </div>
                </div>
                <div class="add-numbermain">
                  <div class="tel-numbers">Message (Max 10 lines)</div>
                  <div className="w-30">
                    <MDBTextArea
                      value={watch("message")}
                      onChange={(e) =>
                        setValue("message", e.target.value, {
                          shouldDirty: true,
                        })
                      }
                    />
                    {errors.message && (
                      <p className="text-danger">{errors.message.message}</p>
                    )}
                  </div>
                </div>
              </>
            )}

            <div class="add-numbermain">
              <div class="tel-numbers mt-2">Choose a PDF file to Fax</div>
              {forwardFlag ? (
                <div className="w-30">{existFileName}</div>
              ) : (
                <div className="w-30">
                  <MDBInput
                    className="form-control"
                    type="file"
                    onChange={handleFileChange}
                    accept=".pdf"
                    ref={fileInputRef}
                  />
                </div>
              )}
            </div>
            {errors?.fax_upload?.file_name && (
              <p className="text-danger">
                {errors?.fax_upload?.file_name.message}
              </p>
            )}

            <div className="bg-secondary bg-opacity-10 d-block p-4 mt-5">
              <h5 className="d-block">Quick Help:</h5>
              <ol>
                <li>
                  Click "Choose File" to locate the file on your computer.
                  Please note that only .pdf files can be faxed
                </li>
                <li>Faxes need to be in standard letter / A4 size</li>
                <li>File size should not exceed 18 MB</li>
                <li>Enter the Fax Number of the fax recipient</li>
                <li>
                  Finally, click send, or click the copy{" "}
                  <MDBIcon far icon="copy" /> icon and paste into the TO: field
                  of your favorite email client. Compose the fax as you would
                  any email with attachments
                </li>
              </ol>
            </div>
          </div>
          {!(groupFaxFlag && userList.length === 0) && (
            <div className="d-flex justify-content-end pe-3">
              <MDBBtn
                className="ms-3"
                disabled={!forwardFlag && !selectedFiles}
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(onsubmit)();
                }}
              >
                Send Fax
              </MDBBtn>
            </div>
          )}

          {successMessage && (
            <>
              <MDBAlert
                open
                className="alert-center"
                color="success"
                autohide
                position="bottom-right"
                delay={5000}
              >
                <i className="fas fa-check-circle me-3"></i>
                <span className="alert-msg">{successMessage}</span>
              </MDBAlert>
            </>
          )}

          {isloading && (
            <>
              <div className="loadingclass">
                <MDBBtn disabled>
                  <MDBSpinner
                    size="sm"
                    role="status"
                    tag="span"
                    className="me-2"
                  />
                  Loading...
                </MDBBtn>
              </div>
            </>
          )}
          {internalError && (
            <MDBAlert
              open
              className="alert-center"
              color="danger"
              autohide
              position="bottom-right"
              delay={5000}
              onClose={() => setInternalError(false)}
            >
              {errorMessage}
            </MDBAlert>
          )}
        </>
      )}
    </>
  );
}

export default SendAFax;
